/** Keep in sync with functions/technical/platform/cache/buildPublicCache.js */

import { app } from '@/firebase/init'
import { isPrerenderBuild } from '@/utils/prerender'

export const PUBLIC_CACHE_SCHEMA_VERSION = 2;
export const TOUR_YEAR_WINDOW = 2;

export function normalizeContinentSlug(continent) {
  return (continent || '').toLowerCase().replace(/\s+/g, '-');
}

export function tourTemplateDocId(continent, slug) {
  return `tourTemplate_${normalizeContinentSlug(continent)}_${slug}`;
}

export function templateDeparturesDocId(templateId) {
  return `templateDepartures_${templateId}`;
}

/**
 * Firebase Storage REST URL for a public cache JSON file.
 * Uses firebasestorage.googleapis.com so Firebase Storage security rules apply
 * (the storage.googleapis.com endpoint bypasses them entirely).
 * @param {string} fileName Base name without path (e.g. "templates" or "tourTemplate_africa_foo")
 */
export function publicCacheUrl(fileName) {
  const bucket = app.options.storageBucket
  const base = String(fileName || '').replace(/\.json$/i, '')
  const objectPath = encodeURIComponent(`public/cache/${base}.json`)
  return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${objectPath}?alt=media`
}

/**
 * Fetch and parse a public cache JSON payload from Storage CDN.
 * During prerender builds, Puppeteer runs on http://127.0.0.1 which is never in
 * the bucket CORS allowlist, so skip the fetch and let callers use their Firestore
 * fallback directly.
 * @param {string} fileName
 * @returns {Promise<object>}
 */
export async function fetchPublicCache(fileName) {
  if (isPrerenderBuild()) {
    throw new Error(`[publicCache] skipping Storage fetch during prerender (${fileName})`)
  }
  const res = await fetch(publicCacheUrl(fileName))
  if (!res.ok) {
    throw new Error(`[publicCache] fetch ${fileName} failed: ${res.status}`)
  }
  return res.json()
}
